import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'jobmonitorEasy';

const jobmonitorEasyService = {
  getProductionOperationsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations/view`,
      data,
    });
  },

  checkOpenProductionReportByUser: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/checkOpenProductionReport/${encodeURIComponent(userId)}`,
    });
  },

  getInterruptedProductions: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/interruptedProductions/${encodeURIComponent(userId)}`,
    });
  },

  createProductionReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionreport`,
      data,
    });
  },

  joinOperation: (prodOperationId, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/joinOperation/${encodeURIComponent(prodOperationId)}/${encodeURIComponent(userId)}`,
    });
  },

  leaveOperation: (prodOperationId, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/leaveOperation/${encodeURIComponent(prodOperationId)}/${encodeURIComponent(userId)}`,
    });
  },

  closeAllOpenedProductionReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/closeAllOpenedProductionReport`,
      data,
    });
  },
};

export default jobmonitorEasyService;
